// Copyright (c) Move Closer 2022.

import { AnyObject } from '@movecloser/front-core'
import {
  CartBillingAddress,
  CartIdentifier,
  CartShippingAddress,
  MagentoCartCountry,
  OrderResponse,
  PaymentMethodPayload,
  ShippingDetails,
  ShippingMethod
} from '../../../../contexts'
import { CartModel, Przelewy24TransactionOutput, OrderStatus } from '../../contracts'
import { Przelewy24PaymentMethodDefinition } from '../../organisms/PaymentStep/PaymentStep.contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const CheckoutServiceType = Symbol.for('ICheckoutService')

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface ICheckoutService {
  loadCountries (): Promise<MagentoCartCountry[]>
  /**
   * @param amount - total grand of cart.
   */
  loadPaymentMethods (amount: number): Promise<Przelewy24PaymentMethodDefinition[]>
  registerPrzelewy24BlikTransaction (input: AnyObject): Promise<Przelewy24TransactionOutput>
  registerPrzelewy24GooglePayTransaction (input: AnyObject): Promise<Przelewy24TransactionOutput>
  setGuestEmail (cartId: CartIdentifier, email: string): Promise<CartModel>
  setBillingAddress (cartId: CartIdentifier, address: CartBillingAddress): Promise<CartModel>
  setInPostParcel (cartId: CartIdentifier, parcelId: string): Promise<void>
  setDHLPopParcel (cartId: CartIdentifier, parcelId: string): Promise<void>
  setShippingAddress (cartId: CartIdentifier, address: CartShippingAddress): Promise<CartModel>
  setShippingDetails (cartId: CartIdentifier, details: ShippingDetails): Promise<CartModel>
  setShippingMethod (cartId: CartIdentifier, shippingMethod: ShippingMethod): Promise<CartModel>
  setPaymentMethod (cartId: CartIdentifier, paymentMethod: PaymentMethodPayload, provider?: AnyObject): Promise<CartModel>
  placeOrder (cartId: CartIdentifier, reviewsRequestConsent?: boolean): Promise<OrderResponse>
  applyGiftCard (cartId: CartIdentifier, giftCardCode: string): Promise<CartModel>
  removeGiftCard (cartId: CartIdentifier, giftCardCode: string): Promise<CartModel>

  // Custom
  setFlightNumberOnCart (cartId: CartIdentifier, flightNo: string): Promise<CartModel>
  setSelectedAddressIdOnCart (cartId: CartIdentifier, addressId: number): Promise<CartModel>
  setIsSignupRequestedOnCart (cartId: CartIdentifier, isSignupRequested: boolean): Promise<CartModel>
  getOrderStatus (orderNumber: string): Promise<OrderStatus>
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const CHECKOUT_CONFIG_KEY = 'checkout'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface CheckoutModuleConfig {
  hasBundledProducts: boolean
}
